module.exports = __webpack_public_path__ + "static/media/mundo.2a32cb58.svg";